import { SET_USER_BRAND_SDK } from "./actions";

const INITIAL_STATE = null;

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
	case SET_USER_BRAND_SDK:
		return {
			...state,
			...action.userBrandSDK,
		};
	default:
		return state;
	}
};
